import React from 'react';

const BorderBeam = ({ 
  size = 100, 
  duration = 12, 
  anchor = 90, 
  borderWidth = 1.5, 
  colorFrom = '#dc2626', 
  colorTo = '#f97316', 
  delay = 0 
}) => {
  return (
    <div
      className="pointer-events-none absolute inset-0 rounded-[inherit]"
      style={{
        '--size': size,
        '--duration': `${duration}s`,
        '--anchor': anchor,
        '--border-width': borderWidth,
        '--color-from': colorFrom,
        '--color-to': colorTo,
        '--delay': `${delay}s`,
        border: `calc(var(--border-width) * 1px) solid transparent`,
        maskClip: 'padding-box, border-box',
        maskComposite: 'intersect',
        WebkitMaskClip: 'padding-box, border-box',
        WebkitMaskComposite: 'xor',
        mask: 'linear-gradient(transparent, transparent), linear-gradient(white, white)',
        WebkitMask: 'linear-gradient(transparent, transparent), linear-gradient(white, white)',
      }}
    >
      <div 
        className="absolute w-full h-full animate-border-beam"
        style={{
          background: `linear-gradient(to right, ${colorFrom}, ${colorTo}, transparent)`,
          width: `${size}px`,
          height: `${size}px`,
          animationDuration: `${duration}s`,
          animationDelay: `${delay}s`,
        }}
      />
    </div>
  );
};

// Simpler animated border that works reliably - always visible
const AnimatedBorder = ({ 
  colorFrom = '#dc2626', 
  colorTo = '#f97316', 
  duration = 3 
}) => {
  return (
    <>
      {/* Animated gradient border - always visible */}
      <div 
        className="absolute inset-0 rounded-[inherit]"
        style={{
          background: `linear-gradient(90deg, ${colorFrom}, ${colorTo}, ${colorFrom})`,
          backgroundSize: '200% 100%',
          animation: `shimmer ${duration}s linear infinite`,
          padding: '2px',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
        }}
      />
      {/* Glow effect on hover */}
      <div 
        className="absolute -inset-1 rounded-[inherit] opacity-0 group-hover:opacity-30 transition-opacity duration-500 blur-md"
        style={{
          background: `linear-gradient(90deg, ${colorFrom}, ${colorTo})`,
        }}
      />
    </>
  );
};

// Border beam for text
const TextBorderBeam = ({ children, className = '' }) => {
  return (
    <span className={`relative inline-block ${className}`}>
      {children}
      <span 
        className="absolute inset-0 rounded-lg"
        style={{
          background: 'linear-gradient(90deg, #dc2626, #f97316, #eab308, #dc2626)',
          backgroundSize: '300% 100%',
          animation: 'shimmer 3s linear infinite',
          WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
          WebkitMaskComposite: 'xor',
          maskComposite: 'exclude',
          padding: '3px',
          opacity: 0.6,
        }}
      />
    </span>
  );
};

export { BorderBeam, AnimatedBorder, TextBorderBeam };
export default BorderBeam;
